import type { SyntaxNode } from 'web-tree-sitter';
import type { SymbolImportBinding } from '../../types.js';
import { extractCIncludeBindings } from './c.js';

export function extractCppImportBindings(
  root: SyntaxNode,
  filePath: string,
  workspaceFiles: ReadonlySet<string>,
): SymbolImportBinding[] {
  return extractCIncludeBindings(root, filePath, workspaceFiles);
}
